import { customerFullName, isSome } from '@crocodille/common';
import Link from 'next/link';
import React from 'react';

import * as routing from '../../../routing';
import ProfileIcon from '../../icons/profile-icon';
import styles from './customer-status.module.scss';

export interface CustomerStatusProps {
  readonly firstName: string | null;
  readonly lastName: string | null;
}

const CustomerStatus: React.FC<
  React.PropsWithChildren<CustomerStatusProps>
> = ({ firstName, lastName }) => {
  const fullName = customerFullName({ firstName, lastName });

  return (
    <Link
      href={routing.ACCOUNT_ORDER_HISTORY}
      prefetch={false}
      className={styles.container}
      title={fullName}
    >
      <ProfileIcon className={styles.icon} />
      <span className={styles.initials}>
        {[firstName?.charAt(0), lastName?.charAt(0)].filter(isSome).join('')}
      </span>
      <span className={styles.name}>{fullName}</span>
    </Link>
  );
};

export default CustomerStatus;
